import { Box, Paper, Stack, Typography } from "@mui/material";
import campaign_sent from "../../../assets/icons/campaign_sent.svg";
import campaign_opened from "../../../assets/icons/campaign_opened.svg";
import campaign_delivered from "../../../assets/icons/campaign_delivered.svg";
import campaign_saved from "../../../assets/icons/campaign_saved.svg";
import campaign_link from "../../../assets/icons/link.svg";
import Exclamatory from "../../../assets/icons/exclamatory.svg";
import UndeliveredModal from "./UndeliveredModal";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import useModalControl from "src/hooks/useModalControl";
const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    padding: "10px"
  },
}));

const CampaignPercentage = ({ data, cardDetail }) => {
  const { open, handleCloseModal, handleOpenModal } = useModalControl()
  const checkButton = cardDetail?.meta_template_data?.components?.find((it) => it.type == 'BUTTONS')

  return (
    <Paper>
      <Stack
        borderRadius="8px"
        justifyContent="space-between"
        gap="10px"
        direction="row"
        width="100%"
        flexWrap="wrap"
        padding="12px"
        border={1}
        borderColor={"divider"}
      >
        <Stack justifyContent="center" spacing={2} alignItems="center">
          <Typography color="primary" variant="h6" fontWeight={500}>{
            data?.total_guests ?
              `${data?.messages_init}( ${((data?.messages_init / data?.total_guests) * 100).toFixed(2)}%  )`
              :
              `0 ( 0.00%  )`

          }</Typography>
          <Stack
            gap={0.5}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            {" "}
            <Box component="img" src={campaign_sent} />
            <Typography color="primary" variant="h6">
              {" "}
              Uploaded
            </Typography>{" "}
          </Stack>
        </Stack>
        <LightTooltip title={
          <Typography variant="caption">
            {
              data?.total_guests ?
                `${((data?.messages_sent / data?.total_guests) * 100).toFixed(2)}% of messages were successfully sent out of ${data?.total_guests} uploaded records.`
                :
                `0.00% of messages were successfully sent out of ${data?.total_guests} uploaded records.`

            }
          </Typography>
        }>
          <Stack justifyContent="center" spacing={2} alignItems="center" sx={{ cursor: "pointer" }}>


            <Typography color="primary" variant="h6" fontWeight={500}>

              {
                data?.total_guests ?

                  `${data?.messages_sent}( ${((data?.messages_sent / data?.total_guests) * 100).toFixed(2)}%  )`
                  :
                  `0( 0.00%  )`

              }</Typography>
            <Stack
              gap={0.5}
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              {" "}
              <Box component="img" src={campaign_sent} />
              <Typography color="primary" variant="h6">
                {" "}
                Sent
              </Typography>{" "}
            </Stack>
          </Stack>
        </LightTooltip>
        <LightTooltip title={
          <Typography variant="caption">
            {data?.messages_sent ?
              `${((data?.messages_delivered / data?.messages_sent) * 100).toFixed(2)}% of messages were successfully delivered out of ${data?.messages_sent} messages sent.`
              :
              `0.00% of messages were successfully delivered out of ${data?.messages_sent} messages sent.`
            }
          </Typography>
        }>


          <Stack justifyContent="center" spacing={2} alignItems="center" sx={{ cursor: "pointer" }}>
            <Typography color="primary" variant="h6" fontWeight={500}>
              {data?.messages_sent ? `${data?.messages_delivered}( ${((data?.messages_delivered / data?.messages_sent) * 100).toFixed(2)}% )` :
                `${data?.messages_delivered}( 0.00% )`
              }
            </Typography>
            <Stack
              gap={0.5}
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              {" "}
              <Box component="img" src={campaign_delivered} />
              <Typography color="primary" variant="h6">
                {" "}
                Delivered
              </Typography>{" "}
            </Stack>
          </Stack>
        </LightTooltip>
        <LightTooltip title={
          <Typography variant="caption">
            {data?.messages_sent ?
              `${((data?.messages_read / data?.messages_sent) * 100).toFixed(2)}% of messages were successfully opened out of ${data?.messages_sent} messages sent.`
              :
              `0.00% of messages were successfully opened out of ${data?.messages_sent} messages sent.`
            }
          </Typography>
        }>
          <Stack justifyContent="center" spacing={2} alignItems="center" sx={{ cursor: "pointer" }}>
            <Typography color="primary" variant="h6" fontWeight={500}>
              {
                data?.messages_sent ?
                  `${data?.messages_read}( ${((data?.messages_read / data?.messages_sent) * 100).toFixed(2)}%  )`
                  :
                  `0( 0.00%  )`
              }
            </Typography>
            <Stack
              gap={0.5}
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              {" "}
              <Box component="img" src={campaign_opened} />
              <Typography color="primary" variant="h6">
                {" "}
                Opened
              </Typography>{" "}
            </Stack>
          </Stack>
        </LightTooltip>
        {(data?.clicksData?.totalUniqueDocuments != undefined && checkButton && checkButton?.buttons?.length > 0) && <LightTooltip title={
          <Typography variant="caption">
            {`${((data?.clicksData?.totalUniqueDocuments / data?.messages_read) * 100).toFixed(
              2
            )}% of messages were successfully opened out of ${data?.messages_read} messages opened.`}
          </Typography>
        }> <Stack justifyContent="center" spacing={2} alignItems="center" sx={{ cursor: "pointer" }}>
            <Typography color="primary" variant="h6" fontWeight={500}>{
              data?.messages_read ?

                `${data?.clicksData?.totalUniqueDocuments}( ${((data?.clicksData?.totalUniqueDocuments / data?.messages_read) * 100).toFixed(2)}%  )`
                :
                `0( 0.00%  )`

            }</Typography>
            <Stack
              gap={0.5}
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              {" "}
              <Box component="img" src={campaign_link} />
              <Typography color="primary" variant="h6">
                {" "}
                Clicked
              </Typography>{" "}
            </Stack>
          </Stack>
        </LightTooltip>
        }
        <LightTooltip title={
          <Typography variant="caption">
            {
              data?.total_guests ?

                `${((data?.messages_failed / data?.total_guests) * 100).toFixed(2)}% of messages were undelivered out of ${data?.total_guests} uploaded records.`
                :

                `0.00% of messages were undelivered out of ${data?.total_guests} uploaded records.`
            }
          </Typography>
        }>
          <Stack justifyContent="center" spacing={2} alignItems="center" sx={{ cursor: "pointer" }}>
            <Typography color="primary" variant="h6" fontWeight={500} sx={{ display: "flex" }}>{
              data?.total_guests ?

                `${data?.messages_failed}( ${((data?.messages_failed / data?.total_guests) * 100).toFixed(2)}%  )`
                :
                `0( 0.00%  )`
            }

              {data?.spam_rate_limit != undefined && <img
                src={Exclamatory}
                alt="image"
                style={{ marginLeft: "8px", cursor: "pointer", width: "18px", }}
                onClick={() =>
                  handleOpenModal()
                }
              />}
            </Typography>
            <Stack
              gap={0.5}
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              {" "}
              <Box component="img" src={campaign_saved} />
              <Typography color="primary" variant="h6">
                {" "}
                Undelivered
              </Typography>{" "}
            </Stack>
          </Stack>
        </LightTooltip>
        {open && <UndeliveredModal open={open} close={handleCloseModal} data={data} />}
      </Stack>
    </Paper>
  );
};

export default CampaignPercentage;
